<template>
  <div class="loading" :class="classes">
    <VProgressCircular v-show="loading" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VProgressCircular from '@/components/atoms/VProgressCircular/VProgressCircular.vue';

interface Props {
  loading?: boolean;
  fullscreen?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  loading: true,
  fullscreen: true,
});

const classes = computed(() => ({
  'loading--fullscreen': props.fullscreen,
}));
</script>

<style lang="scss">
.loading {
  &--fullscreen {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 400;
  }
}
</style>
